import React from "react";
import "./about.css";
// import Me from "../../assets/me-about.jpg";
import Me from "../../assets/me/me5.jpg";
import { FaAward } from "react-icons/fa";
import { FaCertificate } from "react-icons/fa";
import { FaFolder } from "react-icons/fa";

const About = () => {
  return (
    <section id="about">
      <div className="container about_container">
        <div className="about_me">
          <div className="about_me-image">
            <img src={Me} alt="About me" />
          </div>
        </div>
        <div className="about_content">
          <div className="about_cards">
            <article className="about_card">
              <FaAward className="about_icon" />
              <h5>Experience</h5>
              <small>2+ Years Working</small>
            </article>
            <article className="about_card">
              <FaCertificate className="about_icon" />
              <h5>Certificates</h5>
              <small>7+</small>
            </article>
            <article className="about_card">
              <FaFolder className="about_icon" />
              <h5>Projects</h5>
              <small>15+ projects completed</small>
            </article>
          </div>
          <br />
          <br />
          <p>
          Passionate software engineer with one year of experience in designing, developing, and implementing web and mobile applications. I use Python, PHP, JavaScript, and Dart to write clear, concise code that is easy to maintain and troubleshoot. Currently, I am expanding my skills in cloud computing.
          </p>
          <a href="#projects" className="btn btn-primary">
            {" "}
            See my projects
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
